import { makeStyles } from 'tss-react/mui';

export const useAmountCardStyles = makeStyles()((theme) => ({
  row: {
    display: 'flex',
    gap: theme.spacing(2),
    height: '60px',
  },
  field: {
    flex: 1,
    minWidth: 0,
  },
  matchSelect: {
    backgroundColor: theme.palette.background.default,
  },
  innerCriteriaItem: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '219px',
    marginTop: 8,
  },
  learnMore: {
    flexDirection: 'row',
    display: 'flex',
  },
  learnMoreText: {
    whiteSpace: 'break-spaces',
  },
  infoIcon: {
    color: theme.palette.info.main,
    marginRight: 8,
    marginTop: 6,
    cursor: 'default',
    height: '16px',
    width: '16px',
  },
}));

export const useSelectTransactionPickerStyles = makeStyles()((theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
    '& [sharedcomponentid="SEARCH_BOX"].open': {
      width: '100%',
    },
  },
  listArea: {
    flex: 1,
    minHeight: 0,
    // The virtualized list scrolls itself, so this stays unscrolled and
    // just hands its full flex-allocated height down for the list to fill.
    padding: theme.spacing(0, 2, 2, 2),
  },
  manualLine: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

export const useSplitExclusionNoticeStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: theme.shape.radius.lg,
    backgroundColor: theme.palette.background.paper,
  },
  noticeRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  noticeIcon: {
    fontSize: 18,
    color: theme.palette.text.tertiary,
  },
  noticeText: {
    color: theme.palette.text.secondary,
    justifyContent: 'flex-end',
  },
  editButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    border: 'none',
    background: 'none',
    padding: 0,
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  editText: {
    color: 'inherit',
    textDecoration: 'underline',
  },
  editIcon: {
    fontSize: 16,
    color: 'inherit',
  },
}));

export const useExclusionsButtonStyles = makeStyles<{ active: boolean }, 'moneyDirectionButton'>()(
  (theme, { active }, classes) => ({
    fullWidthSplitButton: {
      width: '100%',
      minHeight: 38,
      padding: theme.spacing(0.75, 2),
      borderRadius: theme.shape.borderRadius * 2,
      border: active ? 'none' : `1px solid ${theme.palette.border.main}`,
      backgroundColor: active ? theme.palette.background.default : theme.palette.background.paper,
      color: theme.palette.text.primary,
      '& svg': {
        color: theme.palette.icon.main,
      },
      '&:hover': {
        border: `1px solid ${theme.palette.border.main}`,
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.main,
        '& svg': {
          color: theme.palette.primary.main,
        },
      },
    },
    moneyDirectionSplitWrapper: {
      display: 'flex',
      width: '100%',
      minHeight: 38,
      borderRadius: theme.shape.borderRadius * 2,
      border: `1px solid ${theme.palette.border.main}`,
      // Clips the two adjoining buttons (which have no radius of their own)
      // to the wrapper's rounded corners so the pair reads as one button.
      overflow: 'hidden',
      // Hovering either side should highlight both, so the pair reads as a
      // single button rather than two independently-hoverable buttons.
      [`&:hover .${classes.moneyDirectionButton}`]: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.main,
        '& svg': {
          color: theme.palette.primary.main,
        },
      },
    },
    moneyDirectionButton: {
      display: 'flex',
      flex: 'auto',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(0.5),
      maxHeight: theme.spacing(6.2),
      padding: theme.spacing(0.8),
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    },
    moneyDirectionButtonOut: {
      borderRight: `1px solid ${theme.palette.border.main}`,
    },
    moneyDirectionButtonSelected: {
      backgroundColor: theme.palette.background.default,
    },
    anchor: {
      width: '100%',
    },
    bothIcon: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    menuLabel: {
      padding: theme.spacing(0.5, 2, 1),
    },
    menuItemIcon: {
      minWidth: 24,
    },
    menuItemIconSelected: {
      color: theme.palette.primary.main,
    },
  }),
);
